// Screen-pixel gap between an element on the artboard and the bottom edge of its
// actions toolbar.
export const ACTIONS_TOOLBAR_GAP = 12
